import styles from './bubble.module.css';

const Bubble = ({ children, radius = '10rem' }) => {
  return (
    <div
      className={`${styles.bubble} snf-text-color-white snf-font-45 snf-font-w6 `}
      style={{ borderRadius: radius }}
    >
      {children}
    </div>
  );
};

Bubble.displayName = 'Bubble';
export { Bubble };
